export function stringToStringEnum<E extends {}>(
  stringEmumTypeObject: any,
  value: string | null | undefined,
): E | undefined {
  if (!value) {
    return;
  }

  return Object.values(stringEmumTypeObject).includes(value)
    ? (value as any)
    : undefined;
}

export function enumValues(e: object): string[] {
  return Object.keys(e).map((k) => e[k as any]);
}
